import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { MenuSidebar } from '@/shared/components/menu-sidebar';
import { NavDropdown } from '@/shared/components/nav-dropdown';
import {
  useUiStore,
  useUiStorePersistent,
} from '@/shared/store/ui-store';
import { getConfig } from '@/utils/config';
import { resolveLogoUrl } from '@/utils/logo';
import { Link } from '@tanstack/react-router';
import {
  KeyRoundIcon,
  MenuIcon,
  MessageSquareTextIcon,
} from 'lucide-react';

export function Nav() {
  const { chat } = getConfig();
  const { isDarkMode } = useUiStorePersistent();
  const { setIsMenuSidebarOpen } = useUiStore();

  return (
    <>
      <div className="bg-card border-border flex min-h-[61px] w-full items-center justify-between rounded border px-2">
        <div className="ml-3 flex shrink-0 items-center gap-2">
          <Link to="/">
            <img
              src={resolveLogoUrl(isDarkMode)}
              alt="logo"
              className="h-[16px]"
            />
          </Link>
        </div>

        <div className="hidden w-full 2xl:flex">
          <div
            className={cn(
              'mr-6 ml-7 flex flex-1 items-center gap-2.5',
              'justify-between',
            )}
          >
            <Link
              to="/api-key"
              className="text-muted hover:bg-active truncate rounded-md px-2 py-1"
            >
              <div className="flex items-center gap-2">
                <KeyRoundIcon className="size-4" />
                API-Schlüssel
              </div>
            </Link>

            <div className="flex items-center gap-2">
              <a
                href={chat.baseUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted hover:bg-active truncate rounded-md px-2 py-1"
              >
                <div className="flex items-center gap-2">
                  <MessageSquareTextIcon className="size-4" />
                  e2 Playground
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="ml-2 flex items-center gap-5 sm:mr-3">
          <div className="hidden items-center gap-5 2xl:flex">
            <NavDropdown />
          </div>

          <div className="2xl:hidden">
            <Button
              onClick={() => setIsMenuSidebarOpen(true)}
              variant="ghost"
            >
              <MenuIcon className="size-6" />
            </Button>
          </div>
        </div>
      </div>

      <div className="2xl:hidden">
        <MenuSidebar />
      </div>
    </>
  );
}
